import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared.module";
import { OurPackagesIndexComponent } from "./our-packages-index/our-packages-index.component";
import { OurPackagesRoutingModule } from "./our-packages-routing.module";
import { OurPackagesDetailsComponent } from "./our-packages-details/our-packages-details.component";

@NgModule({
  declarations: [OurPackagesIndexComponent,OurPackagesDetailsComponent],
  imports: [CommonModule, OurPackagesRoutingModule, SharedModule],
})
export class OurPackagesModule {}
